module.exports = __webpack_public_path__ + "static/merch12Back-6c86fd79987305dd6ef4d7ba7e4a1454.png";